import { AxiosError, AxiosResponse } from 'axios';
import toast from 'utils/ToastNotistack';

export async function handleApiCall<T>(
  apiCall: () => Promise<AxiosResponse<T>> | Promise<T>,
  successMessage: string,
  errorMessage: string
): Promise<{ success: boolean; data?: T | null }> {
  try {
    const response = await apiCall();

    // Type guard to check if response is an AxiosResponse
    const data: any = isAxiosResponse(response) ? response.data : response;

    if (data?.type === 'success' && successMessage) {
      toast(successMessage, { variant: 'success' });
      return { success: true, data };
    }

    if (response instanceof AxiosError && response.response?.data?.error?.length) {
      const [firstError] = response.response.data.error;
      toast(firstError, { variant: 'error' });
      return { success: false };
    }

    return { success: false, data: null }; // Return data: null if error occurs
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : errorMessage;
    toast(message, { variant: 'error' });
    return { success: false, data: null }; // Ensure data is set to null on error
  }
}

// Type guard to check if the response is an AxiosResponse
function isAxiosResponse<T>(response: AxiosResponse<T> | T): response is AxiosResponse<T> {
  return (response as AxiosResponse<T>).data !== undefined;
}
